<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission" :searchs="searchs" ref="table"></common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";

    export default {
        name: "UserSetting",
        components: {CommonTable},
        data(){
            return{
                searchs:[
                    {
                        name: 'phone',
                        placeholder: '手机号',
                        type: 'input'
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'userSetting:add',
                    update: 'userSetting:update',
                    delete: 'userSetting:delete',
                    deleteBatch: 'userSetting:deleteBatch'
                },
                url: {
                    get: '/userSetting/listByCondition',
                    add: '/userSetting/add',
                    update: '/userSetting/update',
                    delete: '/userSetting/delete/',
                    delete_batch: '/userSetting/deleteBatch',
                    status: '/userSetting/updateAutoGrab'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                },{
                    field: 'phone',
                    label: '用户',
                    show: true,
                    width: '',
                },{
                    field: 'registerRewards',
                    label: '注册奖励(USDT)',
                    show: true,
                    width: '',
                },{
                    field: 'promotionRewards',
                    label: '推广奖励(USDT)',
                    show: true,
                    width: '',
                },{
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加',
                    updateTitle: '修改',
                    labelWidth: '130px',
                    model: [{
                        field: 'userId',
                        label: '选择会员:',
                        type: 'select',
                        selectUrl: '/userInfo/getAll',
                        selectData: [],
                        placeholder: '请选择会员',
                        rules: [{
                            message: '请选择会员',
                            trigger: 'blur',
                            required: true
                        }],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                        field: 'registerRewards',
                        label: '注册奖励(USDT):',
                        type: 'money',
                        placeholder: '请输入注册奖励金额',
                        rules: [{ message: '请输入注册奖励金额', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'promotionRewards',
                        label: '推广奖励(USDT):',
                        type: 'money',
                        placeholder: '请输入推广奖励金额',
                        rules: [{ message: '请输入推广奖励金额', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }],
                },
                operate: []
            }
        }
    }
</script>

<style scoped>

</style>
